import React from "react";
import { __ } from "@wordpress/i18n";

// Context hooks - replacing Apollo
import { useResult } from "../../../../shared/formContext/hooks/useResult";
import { useForm } from "../../../../shared/formContext/hooks/useForm";

// Components
import Box from "../../../../components/Box/Box";
import Cta from "../../../../components/Cta/Cta";
import IconContent from "../../../../components/IconContent/IconContent";
import ShareFullLink from "../../../../shared/components/ShareFullLink";

// Tab component (just one)
import TabInvestmentEvolution from "../Tabs/TabInvestmentEvolution.tsx";

// Helpers
import { utils } from "../../../../helpers";

/**
 * RetirementInvestment Component
 * @returns JSX element containing the complete retirement investment results display
 */
const RetirementInvestment: React.FC = () => {
  // Use Context hook instead of Apollo reactive variables
  const { resultData } = useResult();
  const { formData } = useForm();
  const { response, loading } = resultData;

  // Extract data from API response
  const retirementData = response?.data?.result?.data;

  if (!retirementData) {
    return null;
  }

  const {
    total_contribution,
    total_interest,
    minimum_contribution_to_goal,
  } = retirementData;

  // Get the contribution frequency from submitted form data
  const contributionFrequency = formData.submitted?.contribution_frequency || 'monthly';

  // Determine the frequency text based on form input
  const frequencyText = contributionFrequency === 'monthly'
    ? __("por mês", "df-simulators")
    : __("por ano", "df-simulators");


  return (
    <div className="simulador-retirement-investment">
      {/* Main Results Box - Following project standard pattern */}
      {response && retirementData && (
        <Box
          grid
          loading={loading}
          header={{
            title: __("Montante de investimento necessário:", "df-simulators"),
            info: `${utils.toEuro(minimum_contribution_to_goal)} ${frequencyText}`,
            color: "orange-100",
          }}
        >
          <IconContent
            title={__("Montante total investido", "df-simulators")}
            color="orange-100"
            bigText={utils.toEuro(total_contribution)}
          />
          <IconContent
            title={__("Montante total dos rendimentos", "df-simulators")}
            color="orange-100"
            bigText={utils.toEuro(total_interest)}
          />

        </Box>
      )}

      {/* Single Chart Section - Evolution */}
      <Box
        loading={loading}
        header={{
          title: __("Evolução do investimento", "df-simulators"),
          textColor: "navy-100",
        }}
      >
        <TabInvestmentEvolution />
      </Box>

      {/* Share Simulation button */}
      <ShareFullLink />

      {/* Call-to-Action - Standard project pattern */}
      <Cta />
    </div>
  );
};

export default RetirementInvestment;
